import { defineStore } from 'pinia';
import EventService from '@/services/EventService';

export const eventStore = defineStore('event', {
  state: () => {
    return {
      events: [],
      loadingEvents: false,
      ticketCounters: {},
    };
  },
  actions: {
    getPublicEvents() {
      this.loadingEvents = true;
      return EventService.getAllPublic().then((res) => {
        this.events = res.data;
        this.loadingEvents = false;
      });
    },
    setTicketCounters(data) {
      const userKey = `user_${data.userId}`;
      for (let eventKey in data.eventTickets) {
        if (!this.ticketCounters[eventKey]) {
          this.ticketCounters[eventKey] = {};
        }
        this.ticketCounters[eventKey][userKey] = data.eventTickets[eventKey];
      }
    },
    updateTicketCounters(data) {
      const eventKey = `event_${data.eventId}`;
      const userKey = `user_${data.userId}`;
      if (!this.ticketCounters[eventKey]) {
        this.ticketCounters[eventKey] = {};
      }
      this.ticketCounters[eventKey][userKey] = data.ticketCount;
    },
    getTicketCount(event) {
      const eventKey = `event_${event.id}`;
      if (!this.ticketCounters[eventKey]) {
        return 0;
      }

      return Object.values(this.ticketCounters[eventKey]).reduce(
        (sum, value) => sum + value,
        0
      );
    },
  },
});
